export default __webpack_public_path__ + "static/media/wegoo1.2a5e76c7.mp4";